import { default as indexTk7qo2k1rpMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/contact/index.vue?macro=true";
import { default as indexCB3VfB1sk0Meta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/cookies/index.vue?macro=true";
import { default as indexZ9CxlTQ02uMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/favorites/index.vue?macro=true";
import { default as indexoRKyrncDk0Meta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/index.vue?macro=true";
import { default as indexsH5hsgmniKMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/login/index.vue?macro=true";
import { default as indexDDJ2167aX2Meta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/password/forgot/index.vue?macro=true";
import { default as indexgXnpMUQLf4Meta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/password/reset/index.vue?macro=true";
import { default as indexDP03pnrDbsMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/privacy/index.vue?macro=true";
import { default as indexH76k7j9EELMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/profile/index.vue?macro=true";
import { default as indexd3dwB1dxEdMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/register/index.vue?macro=true";
import { default as indexOegQyeaiqdMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/reservations/index.vue?macro=true";
import { default as indexKgx5jGFZZuMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/restaurant-owner/index.vue?macro=true";
import { default as indexzTFSDylZOxMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/restaurant-owner/register/index.vue?macro=true";
import { default as _91tab_93qpn3uqIktNMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/restaurants/[slug]/[tab].vue?macro=true";
import { default as indexAqnWHIAPuPMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/restaurants/[slug]/index.vue?macro=true";
import { default as indexp4EkRqfGc9Meta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/search/index.vue?macro=true";
import { default as indexfQN5DSSCYSMeta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/search/map/index.vue?macro=true";
import { default as index62TAv5vmD5Meta } from "/codebuild/output/src3460348356/src/kichieats-front/pages/terms/index.vue?macro=true";
import { default as component_45stub8p2i3M8B76Meta } from "/codebuild/output/src3460348356/src/kichieats-front/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stub8p2i3M8B76 } from "/codebuild/output/src3460348356/src/kichieats-front/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "contact",
    path: "/contact",
    meta: indexTk7qo2k1rpMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/contact/index.vue")
  },
  {
    name: "cookies",
    path: "/cookies",
    meta: indexCB3VfB1sk0Meta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/cookies/index.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    meta: indexZ9CxlTQ02uMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/favorites/index.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexoRKyrncDk0Meta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexsH5hsgmniKMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/login/index.vue")
  },
  {
    name: "password-forgot",
    path: "/password/forgot",
    meta: indexDDJ2167aX2Meta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/password/forgot/index.vue")
  },
  {
    name: "password-reset",
    path: "/password/reset",
    meta: indexgXnpMUQLf4Meta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/password/reset/index.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    meta: indexDP03pnrDbsMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/privacy/index.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexH76k7j9EELMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/profile/index.vue")
  },
  {
    name: "register",
    path: "/register",
    meta: indexd3dwB1dxEdMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/register/index.vue")
  },
  {
    name: "reservations",
    path: "/reservations",
    meta: indexOegQyeaiqdMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/reservations/index.vue")
  },
  {
    name: "restaurant-owner",
    path: "/restaurant-owner",
    meta: indexKgx5jGFZZuMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/restaurant-owner/index.vue")
  },
  {
    name: "restaurant-owner-register",
    path: "/restaurant-owner/register",
    meta: indexzTFSDylZOxMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/restaurant-owner/register/index.vue")
  },
  {
    name: "restaurants-slug-tab",
    path: "/restaurants/:slug()/:tab()",
    meta: _91tab_93qpn3uqIktNMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/restaurants/[slug]/[tab].vue")
  },
  {
    name: "restaurants-slug",
    path: "/restaurants/:slug()",
    meta: indexAqnWHIAPuPMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/restaurants/[slug]/index.vue")
  },
  {
    name: "search",
    path: "/search",
    meta: indexp4EkRqfGc9Meta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/search/index.vue")
  },
  {
    name: "search-map",
    path: "/search/map",
    meta: indexfQN5DSSCYSMeta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/search/map/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index62TAv5vmD5Meta || {},
    component: () => import("/codebuild/output/src3460348356/src/kichieats-front/pages/terms/index.vue")
  },
  {
    name: component_45stub8p2i3M8B76Meta?.name,
    path: "/restaurants",
    component: component_45stub8p2i3M8B76
  }
]